<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <ButtonSecondaryIconSm @click="$emit('cancel')">
                    <ArrowLeftIcon />
                </ButtonSecondaryIconSm>
                <span> {{ social.title }}</span>
            </div>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <component :is="social.icon" class="w-6 h-6 text-primary" />

                <FormInput :title="$t('shared.url')" v-model="social.url" />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="$emit('save')" :disabled="!isDirty" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { FormInput } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        PageSidebar,
        ButtonSecondaryIconSm,
        ArrowLeftIcon,
        FormInput,
        cSaveButton,
    },
    props: {
        social: {
            type: Object,
            required: true,
        },
        backupData: {
            type: Object,
            required: true,
        },
    },
    emits: ["save", "cancel"],
    computed: {
        isDirty() {
            return this.social.url !== this.backupData.url;
        },
    },
};
</script>
